<template>
    <div>
        <div style="padding-top:100px;">
            <div class="container">
                <div class="icon-block ">
                    <h3 class="center-align">Travel Information</h3>
                    <div class="section">
                        <h4>Visa</h4>
                        <ul>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                <a href="https://www.boca.gov.tw/mp-2.html">Bureau of Consular Affairs</a>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                <a href="https://www.boca.gov.tw/lp-181-2-xCat-2.html">eVisa</a>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                <a href="https://www.boca.gov.tw/cp-149-270-9fd80-2.html">Visa-Exempt Entry</a>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                <a href="https://www.boca.gov.tw/cp-161-264-cdb6a-2.html">Visa Fees</a>
                            </li>
                        </ul>
                        <h4>Conference Position</h4>
                        <ul>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>Chinese Name : 臺灣科技大學</li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>English Name : National Taiwan University of Science and Technology (NTUST)</li>
                        </ul>
                    </div>
                    <h4>Halal Restaurant</h4>
                    <ul>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>
                            <a href="https://thpc.taiwantrade.com/restaurant_map#a1">Taipei Halal Restaurant Map</a>
                        </li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>
                            <span> 穆斯林餐廳 is Halal Restaurant</span>
                        </li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>
                            <span> 穆斯林友善餐廳 is Halal Friendly Restaurant</span>
                        </li>
                    </ul>

                    <h3>Accomadation</h3>
                    <div class="alert alert-info">
                        <ul>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Room for one person: about 1000 - 1200 NTD/per night
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Room with others: about 800 - 1000 NTD/per night
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Backpackers: about 800 - 1000 NTD/per night
                            </li>
                        </ul>
                    </div>

                    <div class="divider"></div>

                    <div class="section">
                        <h3 class="center-align">Hostels (For backpackers)</h3>
                        <h4>May Rooms Taipei NTU</h4>
                        <ul>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Room type &amp; Price
                                <ul>
                                    <li>
                                        <i class="medium material-icons ">chevron_right</i> Private Rooms : 1600/per night,per room</li>
                                    <li>
                                        <i class="medium material-icons ">chevron_right</i> Beds in Dorm Rooms : 600/per night, per bed</li>
                                </ul>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                <a href="https://www.booking.com/hotel/tw/may-rooms-taipei-ntu-tai-bei-shi.html?label=gen173nr-1DCAEoggJCAlhYSDNYBGjnAYgBAZgBMLgBB8gBDNgBA-gBAZICAXmoAgM;sid=bdb39c241eb5e464353160012ec3fd94;all_sr_blocks=298752506_110568305_1_1_0;bshb=0;checkin=2018-08-09;checkout=2018-08-15;dest_id=-2637882;dest_type=city;dist=0;group_adults=1;group_children=0;hapos=1;highlighted_blocks=298752506_110568305_1_1_0;hpos=1;no_rooms=1;room1=A;sb_price_type=total;srepoch=1523455317;srfid=efcaa30bef77b446e580192c79c8b22ae8f5e325X1;srpvid=101f62a9eeda0167;type=total;ucfs=1&amp;#hotelTmpl">Information Link</a>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Location (Very close to NTUST)
                            </li>
                        </ul>

                        <h4>Ximen Corner Hostel</h4>
                        <ul>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Room type &amp; Price
                                <ul>
                                    <li>
                                        <i class="medium material-icons ">chevron_right</i> Private Rooms: 2000/per night, per room</li>
                                    <li>
                                        <i class="medium material-icons ">chevron_right</i> Beds in Dorm Rooms : 600/per night, per bed</li>
                                </ul>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                <a href="https://www.booking.com/hotel/tw/here-there-hostel.html?aid=304142;label=gen173nr-1DCAEoggJCAlhYSDNYBGjnAYgBAZgBMLgBB8gBDNgBA-gBAZICAXmoAgM;sid=bdb39c241eb5e464353160012ec3fd94;atlas_src=sr_iw_btn&amp;checkin=2018-08-09&amp;checkout=2018-08-15&amp;group_adults=1&amp;group_children=0&amp;nflt=pri%3D1%3Brshl%3D7%3Brshl%3D8%3Brshl%3D9%3Bht_id%3D203%3B&amp;no_rooms=1&amp;room1=A&amp;sb_price_type=total&amp;srepoch=1523456196&amp;srpvid=a9c66443e91a0068&amp;type=total&amp;">Information Link</a>

                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Location
                                <ul>
                                    <li>
                                        <i class="medium material-icons ">chevron_right</i> MRT : Twenty minutes from ximen Station to Gongguan Station</li>
                                </ul>
                            </li>
                        </ul>

                        <h3 id="Hotels">Hotels</h3>
                        <h4 id="ColorMix-Hotel-amp-Hostel">ColorMix Hotel &amp; Hostel</h4>
                        <ul>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Room type &amp; Price
                                <ul>
                                    <li>
                                        <i class="medium material-icons ">chevron_right</i> Single Room with Shared Bathroom : 1200 NTD</li>
                                </ul>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                <a href="https://www.booking.com/hotel/tw/colormix.html?aid=304142;label=gen173nr-1DCAEoggJCAlhYSDNYBGjnAYgBAZgBMLgBB8gBDNgBA-gBAZICAXmoAgM;sid=bdb39c241eb5e464353160012ec3fd94;atlas_src=sr_iw_btn&amp;checkin=2018-08-09&amp;checkout=2018-08-15&amp;group_adults=1&amp;group_children=0&amp;nflt=pri%3D1%3Bht_id%3D204%3Boos%3D1%3Brshl%3D9%3Breview_score%3D70%3Breview_score%3D80%3B&amp;no_rooms=1&amp;room1=A&amp;sb_price_type=total&amp;srepoch=1523458198&amp;srpvid=9bcb66f2c23e0277&amp;type=total&amp;">Information Link</a>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Location
                                <ul>
                                    <li>
                                        <i class="medium material-icons ">chevron_right</i> MRT : Twenty minutes from ximen Station to Gongguan Station</li>
                                </ul>
                            </li>
                        </ul>

                        <h4 id="NYS-Loft-Hotel">NYS Loft Hotel</h4>
                        <ul>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Room type &amp; Price
                                <ul>
                                    <li>
                                        <i class="medium material-icons ">chevron_right</i> Standard Single Room with Shared Bathroom : 1200 NTD</li>
                                </ul>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                <a href="https://www.booking.com/hotel/tw/nan-yang-jie-yi-hao-lu-dian.html?aid=304142;label=gen173nr-1DCAEoggJCAlhYSDNYBGjnAYgBAZgBMLgBB8gBDNgBA-gBAZICAXmoAgM;sid=bdb39c241eb5e464353160012ec3fd94;atlas_src=sr_iw_btn&amp;checkin=2018-08-09&amp;checkout=2018-08-15&amp;group_adults=1&amp;group_children=0&amp;nflt=pri%3D1%3Bht_id%3D204%3Boos%3D1%3Brshl%3D9%3Breview_score%3D70%3Breview_score%3D80%3B&amp;no_rooms=1&amp;room1=A&amp;sb_price_type=total&amp;srepoch=1523458442&amp;srpvid=9bcb66f2c23e0277&amp;type=total&amp;">Information Link</a>
                            </li>
                            <li>
                                <i class="medium material-icons ">chevron_right</i>
                                Location
                                <ul>
                                    <li>
                                        <i class="medium material-icons ">chevron_right</i> MRT : Thirty minutes from Taipei Main Station to Gongguan Station</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div class="divider"></div>
                    <h3 class="center-align">How-To NTUST</h3>
                    <div id="howto" style="height:500px; z-index:0;"></div>

                    <div class="divider"></div>
                    <h3 class="center-align">MRT Station Name</h3>
                    <h4 id="Red-Line">Red Line</h4>
                    <ul>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>淡水 Danshui</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>紅樹林 Hongshulin</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>竹圍 Zhuwei</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>關渡 Guandu</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>忠義 Zhongyi</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>復興崗 Fuxinggang</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>北投 Beitou</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>新北投 Xinbeitou</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>奇岩 Qiyan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>口其哩岸 Qilian</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>石牌 Shipai</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>明德 Mingde</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>芝山 Zhishan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>士林 Shilin</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>劍潭 Jiantan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>圓山 Yuanshan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>民權西路 Minquan W.Rd.</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>雙連 Shuanglian</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>中山 Zhongshan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>台北車站 Taipei Main Station</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>臺大醫院 NTU Hospital</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>中正紀念堂 Chiang Kai-Shek Memorial Hall</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>古亭 Guting</li>
                    </ul>
                    <h4 id="Green-Line">Green Line</h4>
                    <ul>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>台電大樓 Taipower Building</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>公館 Gongguan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>萬隆 Wanlong</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>景美 Jingmei</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>大坪林 Dapinglin</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>七張 Qizhang</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>小碧潭 Xiaobitan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>新店市公所 Xindan City Hall</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>新店 Xindan</li>
                    </ul>
                    <h4 id="Yellow-Line">Yellow Line</h4>
                    <ul>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>頂溪 Dingxi</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>永安市場 Yongan Market</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>景安 Jingan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>南勢角 Nanshijiao</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>Blue Line</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>永寧 Yongning</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>土城 Tucheng</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>海山 Haishan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>亞東醫院 Far Eastern Hospital</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>府中 Fuzhong</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>板橋 Banciao</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>新埔 Xinpu</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>江子翠 Jiangzicui</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>龍山寺 Longshan Temple</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>西門 Ximen</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>小南門 Xiaonanmen</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>善導寺 Shandao Temple</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>忠孝新生 Zhongxiao Xinsheng</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>忠孝復興 Zhongxiao Fuxing</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>忠孝敦化 Zhongxiao Dunhua</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>國父紀念館 Sun Yat-Sen Memorial Hall</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>市政府 Taipei City Hall</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>永春 Yongchun</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>後山碑 Houshanpi</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>昆陽 Kunyang</li>
                    </ul>
                    <h4 id="Brown-Line">Brown Line</h4>
                    <ul>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>中山國中 Zhongshan Jr. High School</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>南京東路 Nanjing E Rd.</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>大安 Daan</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>科技大樓 Technology Building</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>六張犁 Liuzhangli</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>麟光 Linguang</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>辛亥 Xinhai</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>萬芳醫院 Wangfang Hospital</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>萬芳社區 Wangfang Community</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>木柵 Muzha</li>
                        <li>
                            <i class="medium material-icons ">chevron_right</i>動物園 Taipei Zoo</li>
                    </ul>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
import MRT_Taoyun2NTUST from "../../static/geojson/MRT_Taoyun2NTUST";

export default {
    name: "venue",
    mounted() {
        var howto = L.map("howto").setView([25.0138, 121.5413], 10);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(howto);

        for (var diffLine in MRT_Taoyun2NTUST) {
            var pointArray = [];

            for (var item in MRT_Taoyun2NTUST[diffLine]) {
                pointArray.push(MRT_Taoyun2NTUST[diffLine][item]);
                var marker = L.marker(MRT_Taoyun2NTUST[diffLine][item]).addTo(
                    howto
                );

                if (item.includes("Start") || item.includes("End")) {
                    marker
                        .bindPopup(item, {
                            closeOnClick: false,
                            autoClose: false
                        })
                        .openPopup();
                } else {
                    marker.bindPopup(item);
                }
            }
            var polyline = L.polyline(pointArray, {
                color: diffLine
            }).addTo(howto);
            // zoom the map to the polyline
            //howto.fitBounds(polyline.getBounds());
        }
    }
};
</script>



<style scoped>
.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}

.alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    border-color: #bee5eb;
}
.alert-info hr {
    border-top-color: #abdde5;
}
.alert-info .alert-link {
    color: #062c33;
}

.second {
    display: flex;
    flex-direction: column;
    align-items: center;
}
body {
    font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/venue.vue